import { PrismicImageProps, PrismicLink } from './PrismicTypes';

export const GENERIC_IMAGE = 'PrismicGenericTemplateDataBodyImageComponent';

export interface GenericImagePrimary {
  image: PrismicImageProps;
  link_url: PrismicLink;
  size: 'sm' | 'md' | 'lg';
}

export interface GenericImageContent {
  __typename: typeof GENERIC_IMAGE;
  primary: GenericImagePrimary;
}
